import rawFeatureFlags from './featureFlags.json';

const FEATURE_FLAGS = {
  discoveryTags: rawFeatureFlags?.discoveryTags === true,
  feedPresets: rawFeatureFlags?.feedPresets === true,
  broadcasterDiscovery: rawFeatureFlags?.broadcasterDiscovery !== false,
  categoryDiscovery: rawFeatureFlags?.categoryDiscovery !== false,
};

export function isFeatureEnabled(flagName) {
  if (!(flagName in FEATURE_FLAGS)) {
    return false;
  }
  return Boolean(FEATURE_FLAGS[flagName]);
}

export default FEATURE_FLAGS;
